module.exports = __webpack_public_path__ + "img/no-gps-ship.9acbd605.svg";